import React from 'react';

const DeviceInfo = ({ip, city, country, os, device, client, pageVisit, isBot}) => {
	return ( 
		<React.Fragment>
			<div className="row  justify-content-between mt-4" style={{fontFamily:'Times New Roman, serif'}}>
				<div className="col-12 col-sm-6  text-right ">
					<span className="text-success">Device : </span>
					<span>{device}</span>
				</div>
				<div className="col-12 col-sm-6  text-right ">
					<span className="text-success">OS : </span>
					<span>{os}</span>
				</div>
				<div className="col-12 col-sm-6  text-right" style={{paddingLeft:'15px', paddingRight:"0px"}}>
					<span className="text-success">Client : </span>
					<span>{client}</span>
				</div>
				<div className="col-12 col-sm-6   text-right ">
					<span className="text-success">Robot : </span>
					<span>{isBot === 'No' ? isBot : `Yes, Name : ${isBot}`}</span>
				</div>
				<div className="col-12   text-right ">
					<span className="text-success">IPv4 : </span>
					<span className="mx-2 text-center">{ip}</span>
					<span className="mx-2 text-center">{country}</span>
					<span className="mx-2 text-center">{city}</span>
				</div>
				{/* pages */}
				<div className="col-12 text-right mt-2">
					<span className="text-success">PageView : </span>
				</div>
				{
					pageVisit &&
					pageVisit.map(element => (
						<React.Fragment key={element._id}>
							<div className="col-12 col-sm-6 text-right ">
								<span className="text-dark">{element.page}</span>
							</div>
							<div className="col-12 col-sm-6 text-right ">
								<span className={element.timeOut === '...' ? 'text-info' : 'text-light'}>
									{element.timeOut === '...' ? 'online' : element.timeOut}
								</span>
							</div>
						</React.Fragment>
					))
				}
				<div className="w-75 mx-auto mt-4" style={{borderBottom:'1px solid'}}></div>
			</div>
		</React.Fragment>
	);
}
 
export default DeviceInfo;